import { CreativeCommonStyle } from "./CreativeCommon.css"
import CcSvg from "../images/cc.svg"
import CcBySvg from "../images/cc-by.svg"


const CreativeCommon = () => {

    return <div css={CreativeCommonStyle}>
        <a target="blank" href="https://creativecommons.org/licenses/by/4.0/">
            <img class="cc" src={CcSvg} />
            <img class="ccby" src={CcBySvg} />
        </a>
    </div>

}


export default CreativeCommon